import React from "react";
import { useModal } from "../../../context/ModalContext";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { getContactString } from "../../containers/ChangeHospitalContainer/ChangeHospitalContainer";
import { Divider } from "@mui/material";
import { ClinicLocationIcon, CloseIcon, UserMailIcon } from "../../../components/Icons";
import UserPhoneIcon from "../../../components/Icons/UserPhoneIcon";
import { MODALS } from "../../../config/params";
import { useAllServiceStatusStore } from "../../../hooks";

const OverdueContactModal = () => {
  const { closeModal, openModal } = useModal();
  const { user } = useUserStore();
  const { isUrgentCareOnly }=useAllServiceStatusStore();

  const handleCloseIcon = () => {
    if (isUrgentCareOnly) {
      openModal(MODALS.URGENT_CARE_TRANSITION_MODAL);
    } else {
      closeModal();
    }
  };


  return (
    <div className="flex flex-col w-full xl:w-[27rem]">
      <div className="flex justify-end">
        <CloseIcon
          onClick={handleCloseIcon}
          className="text-light-black cursor-pointer"
        />
      </div>
      <div className="w-full flex flex-col items-center gap-4">
        <div className="text-2xl font-semibold">Contact Hospital</div>
        <div className="w-full p-6 border border-gray-4 rounded-xl bg-white flex flex-col gap-4">
          <div className="flex gap-3">
            <ClinicLocationIcon width={24} height={24} color="#262626" className="mt-1"/>
            <div className="flex flex-col gap-1">
              <div className="font-semibold">
                {`GoodVets ${user?.location?.locationName}`}
              </div>
              <div className="text-xs ">
                {user?.location?.address}
              </div>
            </div>
          </div>
          <Divider className="w-full !m-0" />
          {user && user.location &&
          <div className="flex flex-col gap-3">
            <a href={`mailto:${user.location.email}`} className="flex gap-4 items-center">
              <UserMailIcon width = {20} height = {19} />
              <div className="text-sm font-semibold">
                {user.location.email}
              </div>
            </a>
            <a href={getContactString(user.location.phoneNumber)} className="flex gap-4">
              <UserPhoneIcon width = {20} height = {19} />
              <div className="text-sm font-semibold">
                {user.location.phoneNumber}
              </div>
            </a>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default OverdueContactModal;
